import { NavLink } from "react-router-dom";
import "./sidenav.css";
import ContentOverlayLatest from "./content_overlay_latest";

function SideNavbar() {
  const navItems = [
    { label: "Introduction", path: "/article/IntroductionSection" },
    { label: "Literature Review", path: "/article/LiteratureReview" },
    { label: "Study Area", path: "/article/StudyArea", children: [
      { label: "Study Area (micro-level study)", path: "/article/StudyArea(micro_level_study)" }
    ]},
    { label: "Materials", path: "/article/Materials", children: [
      { label: "Data used: micro study", path: "/article/Dataused(micro_study)" }
    ]},
    { label: "Methods", path: "/article/MethodsSection", children: [
      { label: "Method (for micro-level study)", path: "/article/Method(for_micro_level_study)" }
    ]},
    { label: "Results", path: "/article/ResultsSection", children: [
      { label: "Western Himalayan Region", path: "/article/western_himalayan_region" },
      { label: "Eastern Himalayan Region", path: "/article/eastern_himalayan_region" },
      { label: "Lower Gangetic Plain Region", path: "/article/lower_gangetic_plain" },
      { label: "Middle Gangetic Plain Region", path: "/article/middle_gangetic_plain" },
      { label: "Upper Gangetic Plain Region", path: "/article/upper_gangetic_plain" },
      { label: "Trans-Gangetic Plain Region", path: "/article/trans_gangetic_plain" },
      { label: "Eastern Plateau and Hills Region", path: "/article/eastern_plateau_and_hills" },
      { label: "Central Plateau and Hills Region", path: "/article/central_plateau_and_hills" },
      { label: "Western Plateau and Hills Region", path: "/article/western_plateau_and_hills" },
      { label: "Southern Plateau and Hills Region", path: "/article/southern_plateau_and_hills" },
      { label: "East Coast Plain and Hills Region", path: "/article/east_cost_plain_and_hills" },
      { label: "West Coast Plain and Hills Region", path: "/article/west_cost_plain_and_hills" },
      { label: "Western Dry Region", path: "/article/western_dry" },
      { label: "Gujrat Plain and Hills Region", path: "/article/gujrat_plain_and_hills" },
      { label: <b>Results: Micro Level Study</b>, path: "/article/results(micro_level_study)" }
    ]},
    { label: "Discussion", path: "/article/Discussion" },
    { label: "Conclusion", path: "/article/ConclusionSection" },
    { label: "References", path: "/article/ReferencesSection" },
  ];

  const renderNavLinks = (items) =>
    items.map(({ label, path, children }, idx) => (
      <li key={idx}>
        <NavLink className="nav-link" to={path} activeClassName="active">
          {label}
        </NavLink>
        {children && (
          <ul>{renderNavLinks(children)}</ul>
        )}
      </li>
    ));

  return (
    <ContentOverlayLatest
      text_content={
        <div className="container">
          <div className="row">
            <div id="sidenav">
              <nav className="navbar-nav underline-hover" style={{ borderRadius: "30px" }}>
                <h5>TABLE OF CONTENTS</h5>
                <hr />
                <ul>{renderNavLinks(navItems)}</ul>
              </nav>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default SideNavbar;
